import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-delete-header',
    template: `@if (!callBack && hasRows() && !disableDelete) {
  <div class="btn-action-close-delete" calltoaction [calltoactionTemplate]="deleteAllTemplateRef"></div>
}
@if (callBack && hasRows() && !disableDelete) {
  <div class="btn-action-close-delete" (click)="callBack()"></div>
}
@if (!hasRows() || (hasRows() && disableDelete)) {
  <div class="btn-action-close-disable-delete"></div>
}
<ng-template #deleteAllTemplateRef>
  <div class="block">{{params.message}}</div>
  @if (params.note) {
    <div class="block">{{params.note}}</div>
  }
  <div class="buttonSet">
    <button (click)="cancel()" class="btn-medium-secondary">Cancel</button>
    <button class="btn-medium-primary" (click)="deleteAll()">Remove</button>
  </div>
</ng-template>
`,
    changeDetection: ChangeDetectionStrategy.Eager
})
export class DeleteHeaderComponent implements AgRendererComponent {
    params: any;
    disableDelete:boolean;
    callBack: Function;

    constructor() {}

    agInit(params: any) {
        this.params = params;  
        this.disableDelete = this.params.disableDelete || false;   
        this.callBack = this.params.callBack || null;   
    }

    refresh(): boolean {
        return true;
    }

    cancel() {
        if(typeof this.params.cancel !== "undefined") {
            this.params.cancel.call();
        }
    }

    deleteAll() {
        if(typeof this.params.proceed !== "undefined") {
            this.params.proceed.call();
        }
    }

    hasRows() {
        return this.params.context.componentParent.getRowCount() > 0;
    }
}
